/* MY FIGHT HOUSE - estimation de livraison dynamique (CRO 4.2).
   Calcul sur l'heure de Dubai (UTC+4 toute l'annee, pas d'heure d'ete),
   jamais sur l'heure de l'appareil. Reglages : Parametres du theme →
   "MFH delivery & cart", passes par snippets/mfh-delivery-estimate.liquid. */
(function () {
  'use strict';

  var DUBAI_OFFSET = 4 * 60 * 60 * 1000;
  var DAY = 24 * 60 * 60 * 1000;

  function isoDay(date) {
    return date.toISOString().slice(0, 10);
  }

  /* now : timestamp ms ; config : { cutoff (minutes apres minuit),
     offDays ([0..6], 0 = dimanche), holidays ({ 'YYYY-MM-DD': true }) } */
  function estimate(now, config) {
    var dubai = new Date(now + DUBAI_OFFSET);
    var tomorrow = new Date(dubai.getTime() + DAY);
    var tomorrowOff = config.offDays.indexOf(tomorrow.getUTCDay()) !== -1 || !!config.holidays[isoDay(tomorrow)];
    var seconds = dubai.getUTCHours() * 3600 + dubai.getUTCMinutes() * 60 + dubai.getUTCSeconds();
    var remaining = config.cutoff * 60 - seconds;
    if (!tomorrowOff && remaining >= 60) {
      return { mode: 'before', minutes: Math.ceil(remaining / 60) };
    }
    return { mode: 'after', minutes: 0 };
  }

  function readConfig(el) {
    var holidays = {};
    (el.dataset.holidays || '').replace(/\d{4}-\d{2}-\d{2}/g, function (day) {
      holidays[day] = true;
      return day;
    });
    return {
      cutoff: parseInt(el.dataset.cutoff, 10) || 0,
      offDays: (el.dataset.offDays || '').split(',').filter(Boolean).map(Number),
      holidays: holidays
    };
  }

  function format(el, result) {
    if (result.mode === 'after') return el.dataset.tAfter;
    var hours = Math.floor(result.minutes / 60);
    var minutes = result.minutes % 60;
    var time = hours > 0
      ? el.dataset.tHoursMinutes.replace('[h]', hours).replace('[m]', minutes)
      : el.dataset.tMinutes.replace('[m]', minutes);
    return el.dataset.tBefore.replace('[time]', time);
  }

  function render(el) {
    var target = el.querySelector('[data-mfh-delivery-text]');
    if (!target) return;
    var result = estimate(Date.now(), readConfig(el));
    var message = format(el, result);
    if (target.textContent !== message) target.textContent = message;
    el.dataset.mode = result.mode;
  }

  function renderAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-mfh-delivery]'), render);
  }

  if (typeof module === 'object' && module.exports) {
    module.exports = { estimate: estimate, readConfig: readConfig, format: format };
    return;
  }
  if (window.MFHDelivery) return;
  window.MFHDelivery = { renderAll: renderAll, estimate: estimate };

  renderAll();
  window.setInterval(renderAll, 30000);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) renderAll();
  });
  /* le panneau panier et /cart remplacent leur contenu */
  document.addEventListener('mfh:cart-rendered', renderAll);
})();
